<template>
    <div class="gallery-block">
        <div v-if="gallery.length > 0">
        <v-layout wrap row>
            <v-flex xs12 sm3 v-for="i in gallery" :key="i" class="pa-1">
                <a data-fancybox="gallery" data-type="image" :href="`/img/${directory}/${i}.jpg`">
                    <div class="img-thumbnail">
                    <img :src="`/img/${directory}/${i}sm.jpg`" alt="Maria Danishwar Photo" class="img-fluid">              
                    </div>
                </a>
            </v-flex>
        </v-layout>
        </div>
        <div v-else>
            <p>No images have been uploaded into this gallery yet</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['directory', 'gallery']
    }
</script>